import { Roles } from '@/utils/roles';
import { FeaturesEnum } from '@utils/features';
import {
  AddOrderProductPage,
  OrderCheckoutPage,
  CookingPanelPage,
  OrderDividerPage,
  OrderViewPage,
  OrdersCreatePage,
  OrdersEditPage,
  OrderHistoryPage,
  OpenOrdersPage,
  ClosedOrdersPage,
} from '../elements';
import { pathJoin } from '../paths';
import { resolvePathRoute } from '../generate-route';

const ROOT = 'orders';
export const paths = (root: string): any => ({
  root: {
    path: pathJoin(root, [ROOT]),
    title: 'orders',
    icon: 'mdi:users-outline',
    feature: FeaturesEnum.ORDERS,
    custom: true,
  },
  new: {
    path: pathJoin(root, [ROOT, 'new']),
    element: OrdersCreatePage,
    title: 'new',
    show: true,
    feature: FeaturesEnum.ORDERS_CREATE,
  },
  open_orders: {
    path: pathJoin(root, [ROOT, 'open_orders']),
    element: OpenOrdersPage,
    params: undefined,
    title: 'open_orders',
    show: true,
    isSeparated: true,
    feature: FeaturesEnum.ORDERS_OPEN,
  },
  closed_orders: {
    path: pathJoin(root, [ROOT, 'closed_orders']),
    element: ClosedOrdersPage,
    params: undefined,
    title: 'closed_orders',
    show: true,
    isSeparated: true,
    feature: FeaturesEnum.ORDERS_CLOSED,
  },
  history: {
    path: pathJoin(root, [ROOT, 'history']),
    element: OrderHistoryPage,
    params: undefined,
    title: 'history',
    show: true,
    isSeparated: true,
    feature: FeaturesEnum.ORDERS_HISTORY,
  },
  view: {
    path: (name: string) => pathJoin(root, [ROOT, name]),
    element: OrderViewPage,
    params: ':id',
    feature: FeaturesEnum.ORDERS_VIEW,
  },
  edit: {
    path: (name: string) => pathJoin(root, [ROOT, name, 'edit']),
    guard: [Roles.ADMIN, Roles.ATM],
    element: OrdersEditPage,
    params: ':id',
    title: 'edit',
    feature: FeaturesEnum.ORDERS_EDIT,
  },
  checkout: {
    path: (name: string) => pathJoin(root, [ROOT, name, 'checkout']),
    guard: [Roles.ADMIN, Roles.ATM],
    element: OrderCheckoutPage,
    params: ':id',
    title: 'checkout',
    feature: FeaturesEnum.ORDERS_CHECKOUT,
  },
  add: {
    path: (name: string) => pathJoin(root, [ROOT, name, 'add']),
    element: AddOrderProductPage,
    params: ':id',
    title: 'add',
    feature: FeaturesEnum.ORDERS_ADD,
  },
  divider: {
    path: (name: string) => pathJoin(root, [ROOT, name, 'divider']),
    element: OrderDividerPage,
    params: ':id',
    title: 'divider',
    feature: FeaturesEnum.ORDERS_DIVIDER,
  },
  cook: {
    path: pathJoin(root, [ROOT, 'cook']),
    element: CookingPanelPage,
    params: undefined,
    isFoodCompany: true,
    title: 'KDS',
    isSeparated: true,
    feature: FeaturesEnum.ORDERS_COOK,
    show: true,
  },
});
export const pathOrders = (root: string) => ({
  [ROOT]: resolvePathRoute(paths(root)),
});
